import User from '../../models/User';
import Collection from '../../models/Collection';
import Event from '../../models/Event';
import { isPresentUrl } from '../../Routes';

export const TopBarVisibility = {

  isViewingAs (user) {
    let userValid = user && (User.isAdminViewingAs(user) || User.isDelegatingAs(user));
    let isPresentationMode = isPresentUrl(window.location.pathname);
    return userValid && !isPresentationMode;
  },

  isShowingHeroRibbon (event) {
    return event && (Event.isUserCreated(event));
  },

  isShowingConcurrentSwitcher (event, collection) {
    return event && collection && Collection.isConcurrentEnabled(collection) &&
      // Make sure we are not a Meeting with 1 event
      Collection.getEvents(collection).length > 1 &&
      this.getConcurrentBarCurrentIndex(event, collection) >= 0;
  },

  getConcurrentBarCurrentIndex (event, collection) {
    let currentIndex = -1;
    if (!event || !collection) {
      return currentIndex;
    }

    const eventId = Event.getId(event);
    const events = Collection.getEvents(collection);

    for (let i = 0; i < events.length; ++i) {
      const e = events[i];
      if (Event.getId(e) === eventId) {
        currentIndex = i;
        break;
      }
    }

    return currentIndex;
  }
};
